import React from 'react';
import CookieConsent from 'react-cookie-consent';
import content from '../../content/cookieNotification.yaml';

const CookieNotification = () => {
  const bannerStyle =
    'position: fixed bottom-0 z-50 flex flex-col items-start text-white w-full bg-[#333333] lg:items-stretch';

  return (
    <div
      data-testid="cookieNotification-container"
      className={bannerStyle}
      role="region"
      aria-label="Cookie consent notification"
    >
      <CookieConsent
        buttonClasses="md:mt-4 mt-6 bg-btn-orange text-white border-opacity-0 hover:bg-ginger hover:text-white min-w-[120px] px-25px py-4 text-sm font-bold rounded tracking-tight border border-black transition-all duration-300 lg:mt-0"
        containerClasses="max-w-[1400px] flex flex-col items-start text-sm m-4 md:mx-16 md:text-base lg:flex-row lg:mx-68px lg:items-center lg:justify-between 2xl:mx-auto"
        buttonText={content.cta.dismiss}
        disableButtonStyles
        disableStyles
        expires={1} // cookie expires in 1 day
      >
        <div role="document" aria-label="Cookie consent details">
          <div className="font-normal text-sm leading-5 md:w-9/12">
            <div>
              {content.header} {content.description.line1}
            </div>
            <div className="mt-6">
              {content.description.line2}{' '}
              <a
                href="/cookies"
                className="underline decoration-white font-bold"
                aria-label="Read our cookie policy"
              >
                {content.cta.policy}
              </a>
            </div>
          </div>
        </div>
      </CookieConsent>
    </div>
  );
};

export default CookieNotification;
